import { render, staticRenderFns } from "./DomesticNatural.vue?vue&type=template&id=0d13644a"
import script from "./DomesticNatural.vue?vue&type=script&lang=js"
export * from "./DomesticNatural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports